const initFormState = (entries) => {

  const computeInitValue = (entry) => {
    let initValue = '';
    if (entry.tag === 'select') {
      initValue = entry.selectOptions[0].value ?? entry.selectOptions[0]
    }
    if (entry.tag === 'boxes') {
      if (entry.attributes?.type === 'radio') {
        initValue = '';  // radio: single string value
      } else {
        initValue = entry.checked ?? [];
      }
    }
    if (entry.attributes && entry.attributes.type === 'date') {
      initValue = new Date().toISOString().slice(0, 10)
    }
    return initValue;
  }

  let init = {};
  if (Array.isArray( entries )) {
    entries.forEach( v => {
      const initValue = computeInitValue( v );
      const key = v.fieldname;
      init[key] = {};
      init[key]['value']     = v['value'] ?? initValue;
      init[key]['initValue'] = v['value'] ?? initValue;
      init[key]['initLabel'] = v['label'] ?? '';
      init[key]['touched']   = false;
      init[key]['valid']     = !v['validation'];
      init[key]['message']   = '';        
    });
  } else {
    Object.keys( entries ).forEach( key => {
      const initValue = computeInitValue( entries[key] )
      init[key] = {};
      init[key]['value']     = entries[key]['value'] ?? initValue;
      init[key]['initValue'] = entries[key]['value'] ?? initValue;
      init[key]['initLabel'] = entries[key]['label'] ?? '';
      init[key]['touched']   = false;
      init[key]['valid']     = !entries[key]['validation'];
      init[key]['message']   = '';    
    });
  }

  return init;

} // initFormState

export default initFormState;